<template>
<!-- 搜索历史+热门搜索 -->
<div class="page">
    <!-- 广告 -->
    <div class="advertise" v-show="adver" v-if="nunber == 4 && guagao.ad_id > 0">
        <div class="title">{{ guagao.title }}</div>
        <!-- https://img0.baidu.com/it/u=316865976,2940650346&fm=26&fmt=auto&gp=0.jpg -->
        <div class="pic">
            <van-swipe class="my-swipe" :autoplay="5000" indicator-color="white">
                <van-swipe-item v-for="(item, i) in guagao.img_url" :key="i">
                    <template v-if="!guagao.url[i]">
                        <img :src="item" />
                    </template>
                    <template v-else>
                        <div @click="jumpAdv(guagao.url[i],i)"><img :src="item" /></div>
                    </template>
                </van-swipe-item>
            </van-swipe>
        </div>
        <div class="tips">
            <div class="tip-left">
                <div class="b">广告</div>
                <!--                    <div class="t">广告</div>-->
            </div>
            <div class="tip-right" @click="closeAdver"></div>
        </div>
    </div>
    <!-- 热门搜索 -->
    <div class="hot-search">
        <div class="hot-top">
            <div class="hot-name">热门搜索</div>
            <div class="hot-refresh" @click="rouate" ref="circle"></div>
        </div>
        <div class="hot-content" v-if="hotKeywordsList.length > 0">
            <ul v-for="(con,i) in hotKeywordsList" :key="i">
                <template v-if="con.items">
                    <li @click="selectClick(m,'2',i)" v-for="(m, index) in con.items" :key="index">
                        {{ m }}
                    </li>
                </template>
            </ul>
        </div>
    </div>
    <!-- 历史搜索 -->
    <div class="history-search" v-if="historyList.length != 0">
        <div class="history-top">
            <div class="history-name">历史搜索</div>
            <div class="history-trash" @click="allDele"></div>
        </div>
        <div class="history-content">
            <ul>
                <li v-for="(item, index) in historyList" :key="index" @click="selectClick(item,'3',index)">
                    {{ item }}
                </li>
            </ul>
        </div>
    </div>
</div>
</template>

<script>
import {
    searchHi
} from "@/api/auction";
import {
    scMdFunc
} from "@/assets/js/scData";
export default {
    props: {
        nunber: {
            type: Number
        },
        linkName: {
            type: String,
        },
        watar: {
            type: Boolean,
        },
    },
    data() {
        return {
            // radioValue: "",
            adver: true,
            degree: 360,
            guagao: {}, //广告
            sosoList: {}, //全部数据
            hotKeywordsList: [], //热门搜索
            munn: 0, //热门搜索
            historyList: [], //历史搜索
        };
    },
    // watch: {
    //     radioValue: function (newValue, oldValue) {
    //         this.$emit("childFn", newValue);
    //         console.log(newValue);
    //         console.log(oldValue);
    //     },
    // },
    methods: {
        jumpAdv(url, i) {
            let num = 0;
            switch (this.nunber) {
                case 4:
                    num = 12
                    break;
                case 2:
                    num = 13
                    break;
                case 1:
                    num = 14
                    break;
                case 0:
                    num = 15
                    break;
                case 5:
                    num = 16
                    break;
                default:
                    num = 17
                    break;

            }
            console.log(this.guagao)
            scMdFunc('allClick', {
                cur_page: num + '',
                cur_moudle: num + '-1',
                cur_button: num + '-1-' + Number(i + 1),
                banner_type_id: this.guagao.ad_type || '',
                banner_order_id: this.guagao.orderId || '',
                banner_advertiser_id: this.guagao.advertiserId || '',
                remarks: this.guagao.remarks || '',
                banner_link_type: this.guagao.link_type || '',
                banner_link: this.guagao.banner_link || '',
                banner_englishName: this.guagao.englishName || '',

            })
             window.location.href = url
        },
        // 热门搜索点击事件
        selectClick(item,k,i) {
            console.log(item);
            let num = 0;
            switch (this.nunber) {
                case 4:
                    num = 12
                    break;
                case 2:
                    num = 13
                    break;
                case 1:
                    num = 14
                    break;
                case 0:
                    num = 15
                    break;
                case 5:
                    num = 16
                    break;
                default:
                    num = 17
                    break;

            }
            scMdFunc('allClick', {
                cur_page: num + '',
                cur_moudle: num + '-',
                cur_button: num + '-'+k+'-' + Number(i + 1),

            })
            // this.radioValue=item
            let routerObj=this.$router.resolve({ name: this.linkName })
            window.location.href = routerObj.route.path+"?searchValue=" + encodeURIComponent(item)+'&from='+(this.water ? 'cloud' : '')
            // alert(routerObj.route.path)
            // if(this.linkName=='search'){
            //     window.location.href = "/search/all?searchValue=" + encodeURIComponent(item)+'&from='+(this.water ? 'cloud' : '')
            // }else{
            //     this.$router.push({
            //     name: this.linkName,
            //     query: {
            //         searchValue: encodeURIComponent(item),
            //         from: this.water ? 'cloud' : ''
            //     },
            // });
            // }
            
        },
        //关闭广告
        closeAdver() {
            this.adver = false;
        },
        // 小圆圈刷新
        rouate() {
            console.log("zhuanquan");
            this.$refs.circle.style.transition = "All 0.4s ease-in-out";
            this.$refs.circle.style.transform =
                "rotate(" + this.degree + "deg)";
            this.degree += 360;
            // 小圆圈转圈圈，热门列刷新
            if (this.hotKeywordsList.length > this.munn + 1) {
                this.munn++;
            } else {
                this.munn = 0;
            }
        },
        // 搜索历史全部删除
        allDele() {
            this.$dialog
                .confirm({
                    message: "是否删除全部历史记录？",
                })
                .then(() => {
                    // on confirm
                    localStorage.removeItem('historyList');
                    this.historyList = [];
                })
                .catch(() => {
                    // on cancel
                });
        },
        // 调接口
        getsearchHi() {
            searchHi({
                type: this.nunber
            }).then((res) => {
                if (res.code == 0) {
                    this.sosoList = res.data;
                    this.guagao = res.data.ad;
                    // 热门搜索关键字
                    this.hotKeywordsList = res.data.hotKeywordsList;
                      let num = 0;
                    switch (this.nunber) {
                        case 4:
                            num = 12
                            break;
                        case 2:
                            num = 13
                            break;
                        case 1:
                            num = 14
                            break;
                        case 0:
                            num = 15
                            break;
                        case 5:
                            num = 16
                            break;
                        default:
                            num = 17
                            break;

                    }
                    if(this.guagao.englishName){
                        scMdFunc('bannerExpose', {
                        cur_page: num + '',
                        cur_moudle: num + '-1',
                        cur_button: num + '-1-1',
                        banner_type_id: this.guagao.ad_type || '',
                        banner_order_id: this.guagao.orderId || '',
                        banner_advertiser_id: this.guagao.advertiserId || '',
                        remarks: this.guagao.remarks || '',
                        banner_link_type: this.guagao.link_type || '',
                        banner_link: this.guagao.id || '',
                        banner_englishName: this.guagao.englishName || '',

                    })
                    }
                    
                    // 历史搜索
                    // this.historyKeywordsList = res.data.historyKeywordsList;
                }
            });
        },
    },
    mounted() {
        if (JSON.parse(localStorage.getItem("historyList"))) {
            this.historyList = JSON.parse(localStorage.getItem("historyList"));
        }
    },
    created() {
        this.getsearchHi();
    },
};
</script>

<style lang="scss" scoped>
/* tab栏 */
/* 广告 */
/deep/ .van-dialog {
    border-radius: 1px !important;
}

.advertise {
    width: 18.75rem;
    height: 14.1rem;
    background: #ffffff;
    padding: 0.75rem;
    border-bottom: .25rem solid #f7f7f7;
}

.advertise .title {
    height: 1.1rem;
    font-size: 0.8rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #27282d;
    line-height: 1.1rem;
    margin-bottom: 0.5rem;
    text-align: left;
}

.advertise .pic {
    width: 17.25rem;
    height: 9.7rem;
    border-radius: 0.2rem;
    overflow: hidden;

    /deep/ .my-swipe {
        width: 100%;
        height: 100%;
    }
}

.advertise .pic img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 0.2rem;
}

.advertise .tips {
    display: flex;
    margin-top: 0.5rem;
    align-items: center;
    justify-content: space-between;
}

.tips .tip-left {
    display: flex;
    height: 0.8rem;
    font-size: 0.55rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #969696;
    line-height: 0.8rem;
}

.tip-left .b {
    height: 0.8rem;
    line-height: .8rem;
    border-radius: 0.1rem;
    width: 1.5rem;
    border: 0.03rem solid #979797;
    text-align: center;
    margin-right: 0.3rem;
}

.tip-left .t {
    line-height: .8rem;
}

.tip-right {
    width: 1.1rem;
    height: 0.8rem;
    background-image: url(../../../assets/img/icon_adclose@2x.png);
    background-repeat: no-repeat;
    background-size: 1.1rem 0.8rem;
}

/* 热门搜索 */
.hot-search {
    width: 18.75rem;
    // height: 6.25rem;
    background: #ffffff;
    padding: 0.6rem 0.75rem;
    margin-bottom: 0.25rem;
}

.hot-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.hot-top .hot-refresh {
    width: 0.8rem;
    height: 0.8rem;
    background-image: url(../../../assets/img/icon_search_refresh_light@2x.png);
    background-repeat: no-repeat;
    background-size: 0.8rem 0.8rem;
}

.hot-top .hot-name {
    height: 1.1rem;
    font-size: 0.8rem;
    font-family: PingFang-SC-Bold, PingFang-SC;
    font-weight: bold;
    color: #27282d;
    line-height: 1.1rem;
}

.hot-search .hot-content {
    margin-top: 0.75rem;
}

.hot-search .hot-content ul {
    overflow: hidden;
}

.hot-content li {
    font-size: 0.75rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #27282d;
    line-height: 1.25rem;
    padding: 0.1rem 0.5rem;
    height: 1.35rem;
    border-radius: 0.68rem;
    border: 0.03rem solid #b8b8b8;
    text-align: center;
    float: left;
    margin-right: 0.5rem;
    margin-bottom: 0.5rem;
}

/* 历史搜索 */
.history-search {
    width: 18.75rem;
    background-color: #fff;
    padding: 0.6rem 0.75rem;
}

.history-search .history-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 1.1rem;
    font-size: 0.8rem;
    font-family: PingFang-SC-Bold, PingFang-SC;
    font-weight: bold;
    color: #27282d;
    line-height: 1.1rem;
}

.history-top .history-trash {
    width: 0.8rem;
    height: 0.8rem;
    background-image: url(../../../assets/img/icon_search_delete_light@2x.png);
    background-repeat: no-repeat;
    background-size: 0.8rem 0.8rem;
}

.history-content {
    margin-top: 0.5rem;
}

.history-content li {
    display: flex;
    align-items: center;
    height: 2.1rem;
    border-bottom: 0.05rem solid #dddee3;
    font-size: 0.75rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #27282d;
    line-height: 1.05rem;
}
</style>
